export default function Footer() {
    return (
        <div>
          <footer>
            <div class="container">
            <div class="row">
                <div class="col-sm-12">
                <div class="copyright-box">
                    <p class="copyright">&copy; Copyright <strong>Bikramjit Singh</strong>. All Rights Reserved</p>
                    <div class="credits">
                    
                    </div>
                </div>
                </div>
            </div>
            </div>
        </footer>
        
        </div>
        )
}
